import React from "react";
import { useQuery } from "@apollo/client";
import { Projects, hash } from "../gql/ProjectsQuery";
import {
  ProjectsSubscription,
  hash as hash2,
} from "../gql/ProjectsSubscription";
import ListGroup from "react-bootstrap/ListGroup";

const AvailableProjects = ({ selected, setSelected, current }) => {
  const { data, loading, error, subscribeToMore } = useQuery(Projects, {
    fetchPolicy: "network-only",
    nextFetchPolicy: "network-only",
    context: { headers: { "X-Trust-Key": hash } },
  });

  subscribeToMore({
    document: ProjectsSubscription,
    updateQuery: (prev) => {
      return prev;
    },
    context: { headers: { "X-Trust-Key": hash2 } },
  });

  if (loading) return;

  if (error) return;

  if (data) {
    return (
      <div
        style={{
          width: "300px",
          border: "1px solid grey",
          borderRadius: "8px",
        }}
      >
        <ListGroup style={{ maxHeight: "300px", overflowY: "auto" }}>
          {data.allProjects.nodes
            .filter((el) => {
              if (current.length > 0) {
                return current.every((f) => {
                  return f.projectName !== el.projectName;
                });
              }

              return el;
            })
            .map((projects) => (
              <ListGroup.Item
                action
                eventKey={projects.id}
                variant="info"
                active={selected === projects.projectName}
                onClick={() => setSelected(projects.projectName)}
              >
                {projects.projectName}
              </ListGroup.Item>
            ))}
        </ListGroup>
      </div>
    );
  }
};

export default AvailableProjects;
